import React from 'react';
import { Package, Wrench } from 'lucide-react';

const ProductTypeBadge = ({ type }) => {
  const badges = {
    tile: {
      label: 'Tile',
      icon: Package,
      bgColor: 'bg-blue-100',
      textColor: 'text-blue-800',
      borderColor: 'border-blue-200'
    },
    accessory: {
      label: 'Accessory',
      icon: Wrench,
      bgColor: 'bg-purple-100',
      textColor: 'text-purple-800',
      borderColor: 'border-purple-200'
    }
  };

  const badge = badges[type?.toLowerCase()] || badges.tile;
  const Icon = badge.icon;

  return (
    <span
      className={`inline-flex items-center gap-1 px-2.5 py-0.5 rounded-full text-xs font-medium border ${badge.bgColor} ${badge.textColor} ${badge.borderColor}`}
    >
      <Icon className="w-3 h-3" />
      {badge.label}
    </span>
  );
};

export default ProductTypeBadge;
